const intlTelInput = require('intl-tel-input');
window.intlTelInput = intlTelInput;
